import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import './FormInputHolder.scss';

// 1. Convert to arrow function and destructure props with defaults
const FormInputHolder = ({ children = null }) => {
  // 2. Determine how many children are present to set the layout class
  const childCount = Children.count(children);

  return (
    <div className="form-input-holder__container">
      {Children.map(children, (child) => {
        // 3. Ensure we only clone valid React elements to avoid errors with strings/nulls
        if (!React.isValidElement(child)) return child;

        return cloneElement(child, {
          // 4. Inject the dynamic class name based on the sibling count
          className: `form-input-holder__input-${childCount}`
        });
      })}
    </div>
  );
};

FormInputHolder.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element
  ])
};

export default FormInputHolder;
